import numberFormat from 'number-format.js'

/**
 * Get the display content surrounding the price
 * @param display, the display string
 * @param symbol, the currency symbol
 * @param code, the currency code
 * @returns, an array with the content before and after the price
 */
export const getDisplayContent = (args: {
  display: string
  symbol: string
  code: string
  format: string
  value?: number
}): string[] => {
  const { display, symbol, code, format, value } = args
  let result = display
  result = result.replace('{{symbol}}', symbol)
  result = result.replace('{{code}}', code)
  const splitResult = result.split('{{price}}')
  const prefix = splitResult[0] || ''
  const suffix = splitResult[1] || ''
  const price =
    typeof value === 'number' && result.includes('{{price}}')
      ? numberFormat(format, value)
      : ''
  return [price, prefix, suffix]
}

export const getUnitPrice = (
  unitPrice: number,
  showUnitPrice: boolean,
  priceValue: number,
  units: number
) => {
  if (!showUnitPrice || units <= 1) {
    return 0
  }
  return unitPrice || priceValue / units
}
